import {createQueryStringFromObject} from 'services/urlServices'

export const createGetUrlWithCustomerKey = (getUrl: string, customerKey?: string) => {
  // we conditionally add the user's orgKey to the query params if needed
  if (customerKey) {
    let joinCharacter = '&'
    if (!getUrl.match(/\?([^&]+)=/)) {
      joinCharacter = '?'
    }
    getUrl = `${getUrl}${joinCharacter}${createQueryStringFromObject({
      orgKey: customerKey
    })}`
  }

  return getUrl
}
